import {UI} from "../../../../../../../stem-core/src/ui/UIBase";

import {ConfirmationModal, ConfirmationModalStyle} from "../../../../../../ui/ConfirmationModal";
import {Messages} from "../../../../../../Messages";
import {Link} from "../../../../../../../stem-core/src/ui/UIPrimitives";
import {styleRule, styleRuleInherit} from "../../../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../../../stem-core/src/ui/style/Theme";
import {SubscriptionStore} from "../../../../../../../client/state/SubscriptionStore";


export class AddressInUseModal extends ConfirmationModal {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            address: null,
            cancelLabel: Messages.close,
            title: Messages.addressInUseTitle,
        };
    }

    getDescription() {
        return [
            Messages.addressInUseDescription,

            "."
        ];
    }
}
